import { Injectable, NgZone } from '@angular/core';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';

import { ElPlatform } from '../overlay/mapping';
import { ElLayoutScrollService } from '../../../services/scroll.service';

@Injectable()
export class ElScrollDispatcherAdapter extends ScrollDispatcher {
  constructor(ngZone: NgZone, platform: ElPlatform, protected scrollService: ElLayoutScrollService) {
    super(ngZone, platform);
  }

  scrolled(auditTimeInMs?: number): Observable<CdkScrollable | void> {
    return this.scrollService.onScroll();
  }
}

